import styles from './index.module.sass';
import classNames from 'classnames';

export const TypeToggler = ({ items, activeItem, setActiveItem }: ITypeToggler) => {
  return (
    <div className={styles.type__toggler_wrap}>
      <div className={styles.type__toggler}>
        <span
          className={classNames(
            styles.toggler__option,
            activeItem === 0 && styles.option__active,
          )}
          onClick={() => setActiveItem(0)}
        >
          {items[0]}
        </span>
        <span
          className={classNames(
            styles.toggler__option,
            activeItem === 1 && styles.option__active,
          )}
          onClick={() => setActiveItem(1)}
        >
          {items[1]}
        </span>
      </div>
    </div>
  );
};

interface ITypeToggler {
  items: string[];
  activeItem: number;
  setActiveItem: (val: number) => void;
}
